import { PaginationOverrides } from 'baseui/pagination'
import React from 'react'
import PageInputField from './PageInputField'
import PrevNextButton from './PrevNextButton'

export const getPaginationOverrides = (
  currentPage: number,
  numPages: number,
  onPageChange: (page: number) => void
): PaginationOverrides => {
  return {
    DropdownContainer: {
      component: () => {
        return (
          <PageInputField
            currentPage={currentPage}
            maxPage={numPages}
            onPageChange={onPageChange}
          />
        )
      },
    },
    Select: {
      component: () => null, // Hide the select component completely
    },
    MaxLabel: {
      component: () => null, // Hide "of X" label since it's now in PageInputField
    },
    PrevButton: {
      component: ({ onClick, disabled }) => {
        return (
          <PrevNextButton
            type={'prev'}
            isDisabled={disabled}
            onClick={onClick}
          />
        )
      },
    },
    NextButton: {
      component: ({ onClick, disabled }) => {
        return (
          <PrevNextButton
            type={'next'}
            isDisabled={disabled}
            onClick={onClick}
          />
        )
      },
    },
  }
}
